// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"480":"2b642b57","838":"43c20303"}[chunkId] + ".js";
};